import { FETCH_CANCEL, FETCH_START, FETCH_SUCCESS, FETCH_ERROR, RESET_STATE } from './constants';

export const initialState = {
    fetching: false,
    error: null,
    data: null,
    filters: {},
    fetched: false,
};

/**
 * Create a reducer function to handle all actions relating to API fetching,
 * only if the action's key matches the one the reducer was created with
 * @param  {String} keyName - key identifying type of data
 * @return {Function} a reducer function implementing the common actions
 */
const createReducer = (keyName) =>
    function reducer(state = initialState, action) {
        const { key, type, params, data, error } = action;
        if (key !== keyName) return state;

        switch (type) {
            case FETCH_CANCEL:
            case RESET_STATE:
                return initialState;
            case FETCH_START:
                return {
                    ...initialState,
                    fetching: true,
                    filters: params,
                };
            case FETCH_SUCCESS:
                return {
                    ...state,
                    fetching: false,
                    data,
                    fetched: true,
                };
            case FETCH_ERROR: {
                return {
                    ...state,
                    fetching: false,
                    error,
                };
            }
            default:
                return state;
        }
    };

export default createReducer;
